import axios from 'axiosConfig';
import React, {useState, useEffect} from 'react';
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Container, Row, Col, Form, Button, Nav} from 'react-bootstrap';
import {updateProfile} from "actions/auth";
import RemoveModal from "../common/modals/RemoveModal";
import {logout} from "actions/auth";

// import './Profile.css';

function Profile() {
  const {user: userData} = useSelector((state) => state.auth);
  const [username, setUsername] = useState();
  const [email, setEmail] = useState();
  const [name, setName] = useState();
  const [surname, setSurname] = useState();
  const [currentPassword, setCurrentPassword] = useState();
  const [newPassword, setNewPassword] = useState();
  const [newPassword1, setNewPassword1] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(false);
  const [showPasswordErrors, setShowPasswordErrors] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(false);
  const [passwordMessage, setPasswordMessage] = useState(false);
  const [successPasswordMessage, setSuccessPasswordMessage] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const requirements = [
    {label: 'Minimum of 8 characters', status: false},
    {label: '1 uppercase letter', status: false},
    {label: '1 lowercase letter', status: false},
    {label: '1 number', status: false}
  ];
  const [passwordRequirements, setPasswordRequirements] = useState(requirements);

  const checkPasswordRequirements = (password) => {
    const updatedRequirements = [...requirements];

    updatedRequirements[0].status = password.length >= 8;
    updatedRequirements[1].status = /[A-Z]/.test(password);
    updatedRequirements[2].status = /[a-z]/.test(password);
    updatedRequirements[3].status = /\d/.test(password);

    return updatedRequirements;
  };

  const onChangeNewPassword = (e) => {
    const password = e.target.value;
    setNewPassword(password);
    setPasswordRequirements(checkPasswordRequirements(password));
    setPasswordMatch(password === newPassword1);
  };

  const onChangeNewPassword1 = (e) => {
    const newPassword1 = e.target.value;
    setNewPassword1(newPassword1);
    setPasswordMatch(newPassword === newPassword1);
  };

  useEffect(() => {
    setEmail(userData.user.email);
    setUsername(userData.user.username);
    const [firstName, ...rest] = userData.user.username.split(' ');
    const lastName = rest.length > 0 ? rest.pop() : '';

    setName(firstName);
    setSurname(lastName);
  }, []);

  const onChangeName = (eve) => {
    setName(eve.target.value);
  }

  const onChangeSurname = (eve) => {
    setSurname(eve.target.value);
  }

  const onChangeCurrentPassword = (eve) => {
    setCurrentPassword(eve.target.value);
  }

  const handleChangePassword = (eve) => {
    setMessage('');
    setPasswordMessage('');
    setSuccessPasswordMessage('');
    setShowPasswordErrors(true);

    if (!passwordRequirements.every((req) => req.status) || !passwordMatch)
      return;

    if (currentPassword === newPassword) {
      setPasswordMessage('Your new password cannot be the same as your old password');
      return;
    }

    setLoading(true);
    axios.put(`/api/auth/change-password/`, {old_password: currentPassword, new_password: newPassword})
      .then((response) => {
        setSuccessPasswordMessage('Password has been successfully changed!')

        setCurrentPassword('');
        setNewPassword('');
        setNewPassword1('');
        setShowPasswordErrors(false);
      })
      .catch((error) => {
        try {
          let passwordMessage = error.response.data.old_password || "We couldn't complete your request."
          if (passwordMessage == "Wrong password.")
            setPasswordMessage("The password you entered is incorrect!");
          else
            setPasswordMessage(passwordMessage);
        } catch (e) {
          setPasswordMessage("We couldn't complete your request.");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleSaveChanges = (eve) => {
    setMessage('');
    setPasswordMessage('');
    setSuccessPasswordMessage('');
    setLoading(true);

    axios.put(`/api/auth/profile/`, {username: name})
      .then((response) => {
        dispatch(updateProfile())
        setMessage({type: "success", content: "Changes has been successfully saved!"})
        console.log(response)
      })
      .catch((error) => {
        console.log(error)
        try {
          setMessage({type: "error", content: error.response.data.message || "We couldn't complete your request."})
        } catch (e) {
          setMessage({type: "error", content: "We couldn't complete your request."})
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }
  const handleDeleteProfile = () => {
    // Open the confirmation modal
    setShowDeleteConfirmation(true);
  };
  const handleConfirmDelete = () => {
    // Call the delete API endpoint here
    setLoading(true);

    axios.delete(`/api/auth/delete-user`)
      .then((response) => {
        // Handle success, e.g., redirect to login page
        console.log(response);

        // Close the confirmation modal
        setShowDeleteConfirmation(false);

        // Dispatch the logout action
        dispatch(logout());
        //Navigate to Homepage
        navigate('/');
      })
      .catch((error) => {
        // Handle error
        console.error(error);

        // Close the confirmation modal
        setShowDeleteConfirmation(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // const handleCancelDelete = () => {
  //   // Close the confirmation modal
  //   setShowDeleteConfirmation(false);
  // };
  return (
    <>
      {/* Profile Section */}
      <section id="profile-section" className="mt-5">
        <Container>
          <Row>
            {/* Header */}
            <Col sm={12} className="mb-3">
              <h3>General Information</h3>
            </Col>

            {/* Inputs */}
            <Col sm={12} lg={8} className="mb-4">
              <Row>
                <Col sm={12} lg={6}>
                  <Form.Group className="mb-3 mb-lg-4" controlId="profileForm.NameInput">
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" className="dark-input" value={name} onChange={onChangeName}
                                  placeholder="Name"/>
                  </Form.Group>
                </Col>

                <Col sm={12} lg={6}>
                  <Form.Group className="mb-3 mb-lg-4" controlId="profileForm.SurnameInput">
                    <Form.Label>Surname</Form.Label>
                    <Form.Control type="text" className="dark-input" value={surname} onChange={onChangeSurname}
                                  placeholder="Surname"/>
                  </Form.Group>
                </Col>

                <Col sm={12} lg={6}>
                  <Form.Group className="mb-3 mb-lg-4" controlId="profileForm.EmailInput">
                    <Form.Label>Email</Form.Label>
                    <Form.Control autocomplete="new-email" type="email" className="dark-input" value={email}
                                  placeholder="email" readOnly/>
                  </Form.Group>
                </Col>

                <Col sm={12} lg={6}>
                  <Form.Group className="mb-3 mb-lg-4" controlId="profileForm.PhonenumberInput">
                    <Form.Label>Phone number</Form.Label>
                    <Form.Control type="text" className="dark-input" placeholder="Phone number" disabled/>
                  </Form.Group>
                </Col>

                <Col sm={12} lg={6}>
                  <Form.Group className="mb-3 mb-lg-4" controlId="profileForm.CountryInput">
                    <Form.Label>Country</Form.Label>
                    <Form.Control type="text" className="dark-input" placeholder="Country" disabled/>
                  </Form.Group>
                </Col>

                <Col sm={12} lg={6}>
                  <Form.Group className="mb-3 mb-lg-4" controlId="profileForm.CityInput">
                    <Form.Label>City</Form.Label>
                    <Form.Control type="text" className="dark-input" placeholder="City" disabled/>
                  </Form.Group>
                </Col>

                <Col sm={12}>
                  <Container>
                    <Row className="px-2 pt-4 pb-3" style={{border: "1px solid #4C4B56", borderRadius: "8px"}}>
                      <Col sm={12} className="mb-3">
                        <h5>Change Password</h5>
                      </Col>

                      <Col sm={12} lg={6} className="d-grid">
                        <Form.Group className="mb-3 mb-lg-4" controlId="profileForm.CurrentPasswordInput">
                          <Form.Label>Current password</Form.Label>
                          <Form.Control
                            type="password"
                            className="dark-input"
                            value={currentPassword}
                            onChange={onChangeCurrentPassword}
                            placeholder="Current password"
                            autocomplete="new-password"
                          />
                        </Form.Group>
                        <Button onClick={handleChangePassword} className="mt-auto d-none d-lg-block w-100 btn-primary"
                                style={{height: "48px"}}>Change Password</Button>
                      </Col>

                      <Col sm={12} lg={6}>
                        <Form.Group className="mb-3 mb-lg-4" controlId="profileForm.NewPasswordInput">
                          <Form.Label>New password</Form.Label>
                          <Form.Control
                            type="password"
                            className={"dark-input " + (showPasswordErrors && (passwordRequirements.every((req) => req.status) ? 'is-valid' : 'is-invalid'))}
                            value={newPassword}
                            onChange={onChangeNewPassword}
                            placeholder="New password"
                            autocomplete="new-password"
                          />
                        </Form.Group>

                        <ul>
                          {passwordRequirements.map((req, index) => (
                            <li key={index}
                                className={showPasswordErrors && (req.status ? 'text-success' : 'text-danger')}>
                              {req.label}
                            </li>
                          ))}
                        </ul>

                        <Form.Group className="mb-3 mb-lg-0" controlId="profileForm.ConfirmNewPasswordInput">
                          <Form.Label>Confirm new password</Form.Label>
                          <Form.Control
                            type="password"
                            className={"dark-input " + (showPasswordErrors && (passwordMatch ? 'is-valid' : 'is-invalid'))}
                            value={newPassword1}
                            onChange={onChangeNewPassword1}
                            placeholder="Confirm new password"
                            autocomplete="new-password"
                          />
                        </Form.Group>
                      </Col>
                      <Col sm={12} className="mb-2 d-flex">
                        <Button onClick={handleChangePassword} className="d-block d-lg-none w-100 btn-primary"
                                style={{height: "48px"}}>Change Password</Button>
                      </Col>
                      <Col sm={12} className="">
                        {passwordMessage && (
                          <div className="form-group mt-3">
                            <div className="alert alert-danger mb-2" role="alert">
                              {passwordMessage}
                            </div>
                          </div>
                        )}
                        {successPasswordMessage && (
                          <div className="form-group mt-3">
                            <div className="alert alert-success mb-2" role="alert">
                              {successPasswordMessage}
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Col>
              </Row>
            </Col>

            <Col sm={12} className="mb-3">
              <h5>Notifications</h5>
            </Col>

            <Col sm={12} className="mb-3">
              <Form.Check className="white-checkbox mb-3" type="checkbox" id="notification-checkbox"
                          label="Email notifications about order status changes" defaultChecked/>
              <Form.Check className="white-checkbox mb-3" type="checkbox" id="orders-checkbox"
                          label="Email new orders"/>
              <Form.Check className="white-checkbox mb-3" type="checkbox" id="sms-notification-checkbox"
                          label="Sms notifications about important events" defaultChecked/>
            </Col>

            {message && (
              <Col sm={12} className="mb-3">
                <div className="form-group mt-3">
                  <div className={"alert alert-" + message.type + " mb-2"} role="alert">
                    {message.content}
                  </div>
                </div>
              </Col>
            )}

            <Col sm={12} lg={4} xl={3} className="mb-2">
              <Button onClick={handleSaveChanges} className="w-100 btn-primary">Save changes</Button>
            </Col>
            <Col sm={12} lg={4} xl={3} className="mb-2">
              <Button onClick={handleDeleteProfile} className="w-100 btn-danger">
                Delete my profile
              </Button>
              <RemoveModal
                show={showDeleteConfirmation}
                handleClick={handleConfirmDelete}
                setShow={setShowDeleteConfirmation}
                header="Are you sure you want to delete your Investment Plan?"
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Profile;
